module.exports = __webpack_public_path__ + "img/经济管理_1@2x.2db22fd5.png";